import "./index.css";
import { IoLogOut, IoTicket } from "react-icons/io5";
import { FaCalendarCheck } from "react-icons/fa";
import { IoPersonCircle } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import imageLogo from "../assets/logo_ticket_win.png";
import XLSX from "xlsx-js-style";
import { SiMicrosoftexcel } from "react-icons/si";
import { TfiWorld } from "react-icons/tfi";
import { GrUserAdmin } from "react-icons/gr";
import { FaEye } from "react-icons/fa";
import swal from "sweetalert";
import { formatedDate } from "../utils";
import { useParams } from "react-router-dom";

const HeaderRaffle = ({
  title,
  startTicket,
  endTicket,
  dateRuffle,
  contactName,
  contactPhone,
  ticketsData,
  isAdmin,
  imageUrl
}) => {

  const { id } = useParams();

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Disponible";
      case 2:
        return "Reservado";
      case 3:
        return "Pagado";
      default:
        return "Desconocido";
    }
  };

  const generateAllTickets = () => {
    const allTickets = [];
    for (let i = startTicket; i <= endTicket; i++) {
      const ticketData =
        ticketsData.find((ticket) => ticket.number === i) || {};
      allTickets.push({
        number: i,
        name: ticketData.name || "",
        phone: ticketData.phone || "",
        status: ticketData.status
          ? getStatusText(ticketData.status)
          : "Disponible",
      });
    }
    return allTickets;
  };

  const exportToExcel = () => {
    const allTickets = generateAllTickets();

    const dataForExcel = allTickets.map((ticket) => ({
      Numero: ticket.number,
      Nombre: ticket.name,
      Telefono: ticket.phone,
      Estatus: ticket.status,
    }));

    // Crea la hoja de cálculo
    const ws = XLSX.utils.json_to_sheet(dataForExcel);

    // Estilo para el encabezado
    const headerStyle = {
      fill: {
        fgColor: { rgb: "FFC7CE" },
      },
      font: {
        bold: true,
        color: { rgb: "9C0006" },
      },
      alignment: {
        horizontal: "center",
      },
    };

    // Aplica estilo al encabezado
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: 0 });
      if (!ws[cellAddress]) continue;
      ws[cellAddress].s = headerStyle;
    }

    // Agregar un borde a las celdas
    const cellStyle = {
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      },
    };

    // Aplica el estilo de borde a todas las celdas
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
        if (!ws[cellAddress]) continue;
        ws[cellAddress].s = { ...ws[cellAddress].s, ...cellStyle };
      }
    }

    // Ajusta el tamaño de las columnas
    const colWidths = [];
    for (let col = range.s.c; col <= range.e.c; col++) {
      const maxWidth = Math.max(
        ...dataForExcel.map((row) => String(row[Object.keys(row)[col]]).length)
      );
      colWidths[col] = { wch: maxWidth + 2 }; // Añadir un poco de padding
    }
    ws["!cols"] = colWidths;

    // Crea un nuevo libro y añade la hoja
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tickets");
    XLSX.writeFile(wb, "tickets_comprados.xlsx");
  };

  const showImageModal = () => {
    swal({
      icon: imageUrl, // URL de la imagen que se muestra en el modal
      button: "Cerrar",
    });
  };

  return (
    <div
      style={{
        background: "#121212",
        padding: "25px",
        color: "white"
      }}
    >
      <div className="flex justify-between items-center w-full" style={{
          marginBottom:"10px",
          paddingBottom:"20px",
          borderBottom:"1px dashed gray"
        }}>
      <nav aria-label="breadcrumb" class="w-full  flex gap-2"   >
        <div>
          <img src={imageLogo} alt="" width={"150px"} />
        </div>
        {
          isAdmin && (
            <ol class="flex w-full flex-wrap items-center rounded-md bg-slate-50 px-4 py-2">
            <li class="flex cursor-pointer items-center text-sm text-slate-500 transition-colors duration-300 hover:text-slate-800">
              <a href="/raffles">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                </svg>
              </a>
              <span class="pointer-events-none mx-2 text-slate-800">/</span>
            </li>
            <li class="flex cursor-pointer items-center text-sm text-slate-500 transition-colors duration-300 hover:text-slate-800">
              <a href="/raffles">Mis Rifas</a>
            </li>
          </ol>
          )
        }
       
      </nav>

      {
        isAdmin ? (
          <a href={`/raffles/public/${id}`} className="flex w-full justify-end gap-2 underline decoration-transparent transition duration-300 ease-in-out hover:decoration-inherit">
       <TfiWorld /> <small>Vista pública</small>
      </a>
        ): (
          <a href={`/raffles/${id}`} className="flex w-full justify-end gap-2 underline decoration-transparent transition duration-300 ease-in-out hover:decoration-inherit">
          <GrUserAdmin /> <small>Administrar</small>
         </a>
        )
      }
     
      </div>

      <p style={{ fontSize: "20px" }}>
        <small>Título:</small> <br />
        <strong>{title}</strong>
      </p>
      <div className="options-header mt-3 gap-5">
        <div className="flex flex-row gap-2">
          <div className="option-header">
            <small className="flex gap-1">
              <IoTicket size={16} /> Boletos
            </small>{" "}
            <div style={{ fontSize: "20px", marginTop:"0" }}>
              {startTicket} - {endTicket}
            </div>
          </div>
          <div className="option-header">
            <small className="flex gap-1 mb-2" >
              <FaCalendarCheck size={14} /> Fecha de sorteo
            </small>{" "}
            {dateRuffle ? formatedDate(dateRuffle) : ""}
          </div>
        </div>
        <div className="option-header" style={{ textAlign: "left" }}>
          <strong className="mb-1">Organizador</strong>
          <div className="flex gap-2" style={{ fontSize: "14px" }}>
            {contactName && (
              <div className="flex gap-2">
                <IoPersonCircle size={16} />
                {contactName}
              </div>
            )}
            {contactPhone && (
              <div className="flex gap-2">
                <FaPhoneAlt size={14} />
                {contactPhone}
              </div>
            )}
          </div>
        </div>

        <div className="flex gap-5">
          <button
            className="button-85"
            onClick={showImageModal}
            style={{
              marginTop: "20px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <FaEye /> Ver detalles
          </button>

{isAdmin && (
            <button
              className="option-header"
              onClick={exportToExcel}
              style={{
                marginTop: "20px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                color: "#15d515",
              }}
            >
              <SiMicrosoftexcel /> Exportar a Excel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderRaffle;
